module.exports = __webpack_public_path__ + "img/selected4-min.0bd19566.png";